import { render } from "./QuickLaunchWidget.vue?vue&type=template&id=24f903fc&scoped=true"
import script from "./QuickLaunchWidget.vue?vue&type=script&lang=js"
export * from "./QuickLaunchWidget.vue?vue&type=script&lang=js"

import "./quick-launch-widget.scss?vue&type=style&index=0&id=24f903fc&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f903fc"]])

export default __exports__